<template>
  <am-tab-arrow-scroller
    :arrowScroll="arrowScroll"
    @scrollToLast="scrollIntoView = tabs.length - 1"
    @scrollToFirst="scrollIntoView = 0"
  >
    <am-tab-bar :scrollIntoView="scrollIntoView">
      <am-tab-scroller>
        <am-tab
          v-for="tab in tabs"
          :id="tab.id || `am-tab-${tab.value}`"
          :key="tab.value"
          :active="tab.value === value"
          :minWidth="minWidth"
          :href="tab.href"
          @change="onChange(tab.value, $event)"
        >
          {{ tab.label }}
        </am-tab>
      </am-tab-scroller>
    </am-tab-bar>
  </am-tab-arrow-scroller>
</template>

<script>
import AmTab from "./Tab.vue";
import AmTabBar from "./TabBar.vue";
import AmTabScroller from "./TabScroller.vue";
import AmTabArrowScroller from "./TabArrowScroller.vue";

export default {
  inheritAttrs: false,
  components: {
    AmTab,
    AmTabBar,
    AmTabScroller,
    AmTabArrowScroller
  },
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    /**
     * Array of objects describing tabs: Array<{value: String | Number, label: String}>
     */
    tabs: {
      type: Array,
      required: true
    },

    /**
     * Unique tab index
     */
    value: {
      type: [String, Number],
      default: ""
    },

    /**
     * Shall tabs titles be spread across container or have minimal width
     */
    minWidth: {
      type: Boolean,
      default: false
    },

    /**
     * Enable or disable arrow scroll
     */
    arrowScroll: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      scrollIntoView: 0
    };
  },
  methods: {
    onChange(tab, value) {
      if (value) {
        /**
         * Change tab event String|Number
         * @type {String|Number}
         */
        this.$emit("change", tab);
      }
    }
  }
};
</script>
